import {ajax} from "rxjs/observable/dom/ajax";
import {Observable} from "rxjs/Observable";
import {LOGIN_FAILURE, LOGIN_SUCCESS} from "../reducers/login";

const TRIGGER_LOGIN = "TRIGGER_LOGIN";
const TRIGGER_AUTH_TEST = "TRIGGER_AUTH_TEST";

const TRIGGER_LOGOUT = "TRIGGER_LOGOUT";

export const triggerLogout = (dispatch) => {
    dispatch({type: TRIGGER_LOGOUT});
};

export const triggerLogin = (dispatch, values) => dispatch({type: TRIGGER_LOGIN, values});

export const triggerAuthTest = dispatch => {
    dispatch({
        type: TRIGGER_AUTH_TEST
    });
};

const handleLogin = (loginValues) => {
    let data = {
        url: '/api/user',
    };
    if (loginValues) {
        data.headers = {
            authorization: `Basic ${btoa(loginValues.username + ":" + loginValues.password)}`
        }
    }
    return ajax(data)
        .map(response => {
            return {
                type: LOGIN_SUCCESS
            };
        })
        .catch(error => {
            console.log("ERROR", error);
            return Observable.of({
                type: LOGIN_FAILURE,
                message: loginValues && error.status === 401 ? 'Invalid Username / Password' : undefined
            });
        })
};


export const authTest = action$ => {
    return action$.ofType(TRIGGER_AUTH_TEST)
        .switchMap(action => {
            return handleLogin();
        })
};

export const loginEpic = action$ => {
    return action$.ofType(TRIGGER_LOGIN)
        .switchMap(action => {
            return handleLogin(action.values);
            }
        );
};

export const logoutEpic = action$ => {
    return action$.ofType(TRIGGER_LOGOUT)
        .switchMap(action => {
            return ajax.post('/api/logout')
                .map(response => {
                    return {
                        type: LOGIN_FAILURE
                    };
                })
                .catch(error => {
                    return {
                        type: LOGIN_FAILURE
                    }
                    })
            }
        );
};


// WEBPACK FOOTER //
// ./src/epics/login.js